import React, { useEffect, useState } from "react";
import cx from "classnames";
import { ModalConsumer } from '../../common/ModalContext';
import { getTextInspiration } from '../../services/textsAdd';
import Button from "../../components/Button/Button"
import Icon from "../../components/Icon/Icon";
import CheckIcon from '../../icons/check.svg'
import { addNew } from "../../services/textsForm";
import styles from "./StepsForm.module.scss";

const StepsForm = ({ firstStepFields, secondStepFields, thirdStepFields, type, manageNextStep, stepsAmount, resetStep }) => {
    const [step, setStep] = useState(1);
    const getFieldsByStep = () => {
        switch (step) {
            case 1:
                return firstStepFields;
            case 2:
                return secondStepFields;
            case 3:
                return thirdStepFields;
        }
    }

    const onNextStep = async () => {
        const result = await manageNextStep(step)
        if (!!result && step !== stepsAmount) {
            setStep(step + 1)
        }
    }

    const getStepsIndicator = () => {

        const stepsAmountArray = []
        for (let i = 1; i <= stepsAmount; i++) {
            stepsAmountArray.push(i)
        }

        return stepsAmountArray
    }

    useEffect(() => {
        if (resetStep) setStep(1)
    }, [resetStep])

    return (
        <div className={styles.container}>
            <div className={styles.panelLeft}>
                <div className={styles.panelText}>
                    <p className={styles.title}>{addNew.title[type]}</p>
                    <p className={styles.inspirationTextLeft}>{getTextInspiration(type)}</p>
                </div>
                <div className={styles.stepContainer}>
                    {getStepsIndicator().map(item => <div className={styles.step} key={item}>
                        <div className={styles.circlePanel} >
                            {item > 1 && <div className={cx(styles.stem, {
                                [styles.stemActive]: item === step || step > item
                            })}></div>}
                            <div className={cx(styles.circle, {
                                [styles.circleActive]: item === step || step > item
                            })}>
                                {step > item ? <Icon name={CheckIcon} /> : <div className={cx(styles.circleIn, {
                                    [styles.circleInActive]: item === step || step > item
                                })}></div>}
                            </div>
                        </div>
                        <div className={cx(styles.stepText, {
                            [styles.stepTextActive]: item === step
                        })}>Step {step}</div>
                    </div>
                    )}
                </div>
            </div>
            <div className={styles.formContainer}>
                <div className={styles.stepContainerMobile}>
                    {getStepsIndicator().map(item => <div className={styles.step} key={item}>
                        <div className={styles.circlePanel} >
                            {item > 1 && <div className={cx(styles.stem, {
                                [styles.stemActive]: item === step || step > item
                            })}></div>}
                            <div className={cx(styles.circle, {
                                [styles.circleActive]: item === step || step > item
                            })}>
                                {step > item ? <Icon name={CheckIcon} /> : <div className={cx(styles.circleIn, {
                                    [styles.circleInActive]: item === step || step > item
                                })}></div>}
                            </div>
                        </div>
                        <div className={cx(styles.stepText, {
                            [styles.stepTextActive]: item === step
                        })}>Step {step}</div>
                    </div>
                    )}
                </div>
                {getFieldsByStep()}
                <div className={styles.stepsManagment}>
                    <div>
                        {step !== stepsAmount && <Button className={styles.nextButton} onClick={() => onNextStep()}>Next</Button>}
                        {step === stepsAmount && <ModalConsumer>
                            {({ toggleModal }) => {
                                return (
                                    <Button
                                        className={styles.nextButton}
                                        onClick={(e) => manageNextStep(step, toggleModal)}
                                        type="submit"
                                    >
                                        {addNew.send}
                                    </Button>
                                );
                            }}
                        </ModalConsumer>}
                        {step !== 1 && <Button className={styles.backButton} onClick={() => setStep(step - 1)}>Back</Button>}
                    </div>

                </div>
            </div>
        </div>
    )
};

StepsForm.propTypes = {

};


export default StepsForm;

